export const noticeGet = "/sys/notices";//获取列表
export const noticepost = "/sys/notices";//新建列表
export const noticeSeach = (id) => {return "/sys/notices/" + id};//查看详情
export const noticePut = (id) => {return "/sys/notices/" + id};//修改公告
export const noticeDel = (id) => {return "/sys/notices/" + id};//删除公告
export const startPut = (id) => {return "/sys/notices/" + id + "/publish"};//修改公告
export const bearPut = (id) => {return "/sys/notices/" + id + "/rollback"};//删除公告
